import { NgTemplateOutlet } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { PageComponent } from "@components/page/page.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { Subject, asapScheduler } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DirtyFormService, IDirtyFormResult } from "~app/common/services/dirty-form.service";
import {
    IHandelssortimentModifications,
    ISearchHandelssortimentModel,
    UpdateMinaHandelssortimentCommand
} from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { HotkeyDirective } from "../../../common/directives/hotkey/hotkey.directive";
import { MinaHandelssortimentService } from "../services/mina-handelssortiment.service";
import { MinaHandlessortimentListComponent } from "./mina-handelssortiment-list/mina-handelssortiment-list.component";
import { MinaHandelssortimentResultViewModel } from "./mina-handelssortiment-result-view-model";
import { MinaHandlessortimentResultComponent } from "./mina-handelssortiment-result/mina-handelssortiment-result.component";
import { MinaHandlessortimentSearchPanelComponent } from "./mina-handelssortiment-search-panel/mina-handelssortiment-search-panel.component";
import { MinaHandelssortimentTexts } from "./mina-handelssortiment.texts";

@Component({
    selector: "rask-mina-handelssortiment",
    templateUrl: "./mina-handelssortiment.component.html",
    styleUrls: ["./mina-handelssortiment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        MinaHandlessortimentListComponent,
        MinaHandlessortimentSearchPanelComponent,
        MinaHandlessortimentResultComponent,
        PageComponent,
        NgTemplateOutlet,
        ButtonComponent,
        HotkeyDirective,
        NgbTooltip
    ]
})
export class MinaHandelssortimentComponent implements OnInit {
    closing = new Subject<void>();
    closingDirty = new Subject();
    currentHandelssortiment: ISearchHandelssortimentModel[];
    handelssortimentListaUtsokta: ISearchHandelssortimentModel[];
    handelssortimentModifications: IHandelssortimentModifications[] = [];
    isModalActive = false;
    minaHandelssortimentList: MinaHandelssortimentResultViewModel[];
    saved = new Subject<void>();
    texts = MinaHandelssortimentTexts.texts;

    private readonly busyService = inject(BusyService);
    private readonly dirtyFormService = inject(DirtyFormService);
    private readonly handelssortimentService = inject(MinaHandelssortimentService);

    canSave() {
        return this.handelssortimentModifications?.length > 0;
    }

    dirtyCheckCallback(result: IDirtyFormResult): void {
        this.closingDirty.next(result);
    }

    ngOnInit(): void {
        this.dirtyFormService.onDirtyNgModel(
            this.canSave.bind(this),
            this.saveMinaHandelssortimentFavoriter.bind(this),
            d => this.dirtyCheckCallback(d),
            () => this.canSave(),
            this.texts.leaveDirtyHeader,
            this.texts.leaveDirtyBody,
            { size: "lg",
                centered: true });
    }

    onAddHandelssortiment(id: number) {
        this.currentHandelssortiment = this.handelssortimentListaUtsokta.filter(item => (item.id === id));
    }

    onClose() {
        if (this.dirtyFormService.canClose()) {
            this.closing.next();
        }
    }

    onHandelssortimentModifications(event: IHandelssortimentModifications[]) {
        asapScheduler.schedule(() => {
            this.handelssortimentModifications = event;
        });
    }

    onMinaHandelssortimentList(event: MinaHandelssortimentResultViewModel[]) {
        this.minaHandelssortimentList = event;
    }

    onSearch(event: ISearchHandelssortimentModel[]) {
        this.handelssortimentListaUtsokta = event;
    }

    saveMinaHandelssortimentFavoriter = (): void => {
        const addedHandelssortiment = this.handelssortimentModifications.filter(p => p.state === "Added");
        const deletedHandelssortiment = this.handelssortimentModifications.filter(p => p.state === "Deleted");

        this.busyService.addWork(this.handelssortimentService.saveMinaHandelssortiment(
            new UpdateMinaHandelssortimentCommand(addedHandelssortiment.map(p => p.id), deletedHandelssortiment.map(p => p.id))), "Sparar..")
            .subscribe(() => {
                this.handelssortimentModifications = [];
                this.saved.next();
            });
    };
}
